import React, { useState } from "react";
import { routerActions } from "connected-react-router";
import { bool } from "prop-types";
import * as i18n from "util/i18n";
import Notification from "pages/_components/Notification";
import MainContainer from "pages/_components/MainContainer";
import { Col, Row } from "react-bootstrap";
import CustomButton from "pages/_components/CustomButton/CustomButton";
import { TransactionCard, TransactionHeader } from "pages/_components/TransactionCard";
import { ResponsiveHeader } from "pages/_components/header";
import DepositsSummary from "./components/DepositsSummary";
import { useCancelRenewalTransaction } from "./hooks/useCancelRenewalTransaction";

const PendingCancelRenewalPage = ({ isDesktop }) => {
    const { isLoading, transaction, dispatch, showSignButton, isBackoffice } = useCancelRenewalTransaction();
    const [showMoreData, setShowMoreData] = useState(!isDesktop);

    const handleSignTransaction = () => {
        const { data, idTransaction } = transaction;
        dispatch(routerActions.push(`/deposits/${data.depositId}/cancelRenewal`, { idTransaction }));
    };

    return (
        <>
            <Notification scopeToShow="deposits" />
            {!isBackoffice && (
                <ResponsiveHeader
                    ticket
                    id="activities.deposit.cancelRenewal.send"
                    metaTitle="activities.deposit.cancelRenewal.send"
                />
            )}
            <MainContainer showLoader={isLoading}>
                <TransactionCard transaction={transaction}>
                    <TransactionHeader title="activities.deposit.cancelRenewal.send" />
                    <div className="ticket">
                        <div className="ticket__wrapper">
                            <div className="ticket__header" />
                            <DepositsSummary
                                isTicket
                                isDesktop={isDesktop}
                                setShowMoreData={setShowMoreData}
                                showMoreData={showMoreData}
                            />

                            <div className="ticket__footer" data-copytext={i18n.get("global.ticketCopyText")} />
                        </div>
                    </div>
                </TransactionCard>
                {!isBackoffice && (
                    <Row className="form-actions">
                        <Col xs={12} md={4} mdOffset={showSignButton ? 2 : 4}>
                            <CustomButton
                                func={() => dispatch(routerActions.push("/desktop"))}
                                text="forms.transaction.ticket.actions.backToHome"
                                textType="I18N"
                                className={`btn${showSignButton ? " btn-outline" : " btn-primary"}`}
                                image="images/share-primary.svg"
                            />
                        </Col>
                        {showSignButton && (
                            <Col xs={12} md={4}>
                                <CustomButton
                                    func={handleSignTransaction}
                                    text="forms.signTransaction.link"
                                    textType="I18N"
                                    className="btn btn-primary"
                                    image="images/download.svg"
                                />
                            </Col>
                        )}
                    </Row>
                )}
            </MainContainer>
        </>
    );
};

PendingCancelRenewalPage.propTypes = {
    isDesktop: bool.isRequired,
};

export default PendingCancelRenewalPage;
